import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useSidebar } from '@/context/SidebarContext';
import styles from './MainLayout.module.css';

export default function MainLayout() {
  const { isOpen, isMobile, setIsMobile, close } = useSidebar();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setIsMobile]);

  return (
    <div className={styles.layout}>
      <Header />
      <div className={styles.container}>
        {isMobile && isOpen && <div className={styles.overlay} onClick={close} />}
        <Sidebar />
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
